import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ebd4fea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "duplicate-table"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 4,
  class: "amount-wrap"
};
const _hoisted_6 = {
  key: 5,
  class: "status-wrap"
};
import { Empty } from 'ant-design-vue';
import { usePagination } from '@/hooks/usePagination';
import DuplicateDetail from './DuplicateDetail.vue';
import { awaitWrap, OK } from '@/common';
import { queryResendOrderListV2 } from '@/api/orderApi';
import { copy } from '@/common';
import { getOrderPermissionIds, useIncomePermissionQuery } from '@/hooks/useIncomePermissionQuery';
export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicateTable',
  setup(__props, {
    expose
  }) {
    const columns = [{
      title: 'DBT订单号',
      dataIndex: 'orderNo',
      key: 'orderNo'
    }, {
      title: '三方订单号',
      dataIndex: 'platOrderNo',
      key: 'platOrderNo'
    }, {
      title: '设备ID',
      dataIndex: 'deviceId',
      key: 'deviceId'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '金额',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '操作复送时间',
      dataIndex: 'reshipStatusTime',
      key: 'reshipStatusTime',
      width: 180
    }, {
      title: '复送完成时间',
      dataIndex: 'reshipFinishTime',
      key: 'reshipFinishTime',
      width: 180
    }, {
      title: '复送状态',
      dataIndex: 'reshipStatus',
      key: 'reshipStatus'
    }, {
      title: '操作人',
      dataIndex: 'reshipOperatorName',
      key: 'reshipOperatorName'
    }, {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      align: 'right',
      fixed: 'right'
    }];
    const dataSource = ref([]);
    const duplicateDetailRef = ref(null);
    const currentIndex = ref(1);
    const searchObj = ref({});
    const {
      loading,
      state,
      emptyDescription,
      begin
    } = useIncomePermissionQuery();
    // 总数缺失时仍按游标翻页；空页回退重新请求，不恢复旧权限下缓存的数据。
    const pageRequests = new Map();
    let cursorPageSize = 0;
    const handleOperation = record => {
      duplicateDetailRef.value.open(record);
    };
    const getDuplicateList = async () => {
      if (cursorPageSize !== pageSize.value) {
        pageRequests.clear();
        dataSource.value = [];
        currentIndex.value = pageIndex.value = 1;
        cursorPageSize = pageSize.value;
      }
      let pageArrow = '1';
      let lastId = '';
      let lastOrderNo = '';
      // 判断是否是下一页
      if (pageIndex.value >= currentIndex.value) {
        var _dataSource$value, _dataSource$value2;
        lastId = ((_dataSource$value = dataSource.value[dataSource.value.length - 1]) === null || _dataSource$value === void 0 ? void 0 : _dataSource$value.id) || '';
        lastOrderNo = ((_dataSource$value2 = dataSource.value[dataSource.value.length - 1]) === null || _dataSource$value2 === void 0 ? void 0 : _dataSource$value2.orderNo) || '';
      } else {
        var _dataSource$value$, _dataSource$value$2;
        pageArrow = '0';
        lastId = ((_dataSource$value$ = dataSource.value[0]) === null || _dataSource$value$ === void 0 ? void 0 : _dataSource$value$.id) || '';
        lastOrderNo = ((_dataSource$value$2 = dataSource.value[0]) === null || _dataSource$value$2 === void 0 ? void 0 : _dataSource$value$2.orderNo) || '';
      }
      currentIndex.value = pageIndex.value;
      const params = {
        lastId,
        lastOrderNo,
        pageArrow,
        pageSize: pageSize.value,
        ...searchObj.value,
        ...pageRequests.get(pageIndex.value)
      };
      pageRequests.set(pageIndex.value, {
        ...params
      });
      const permissionRequest = begin(getOrderPermissionIds(params));
      dataSource.value = [];
      pageTotal.value = 0;
      try {
        const [err, res] = await awaitWrap(queryResendOrderListV2(params));
        if (!permissionRequest.isCurrent()) return;
        if (err || (res === null || res === void 0 ? void 0 : res.code) !== OK) {
          permissionRequest.fail();
          return void 0;
        }
        if (res && res.code === OK) {
          var _result$count;
          const result = res;
          permissionRequest.accept(result);
          dataSource.value = result.data || [];
          pageTotal.value = (_result$count = result.count) !== null && _result$count !== void 0 ? _result$count : 0;
        }
      } catch (error) {
        permissionRequest.fail();
      } finally {
        permissionRequest.finish();
      }
    };
    const searchData = obj => {
      pageRequests.clear();
      searchObj.value = {
        ...obj
      };
      dataSource.value = [];
      currentIndex.value = 1;
      pageIndex.value = 1;
      getDuplicateList();
    };
    const {
      pageTotal,
      pageIndex,
      pageSize,
      currentPageSizeChange
    } = usePagination(() => {
      getDuplicateList();
    });
    expose({
      searchData,
      permissionState: state
    });
    return (_ctx, _cache) => {
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_statistic = _resolveComponent("a-statistic");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_table, {
        loading: _unref(loading),
        columns: columns,
        "data-source": dataSource.value,
        bordered: "",
        pagination: false,
        scroll: {
          y: 'calc(100% - 80px)',
          x: 1500
        },
        class: "new-order-table"
      }, {
        emptyText: _withCtx(() => [_createVNode(_component_a_empty, {
          image: _unref(Empty).PRESENTED_IMAGE_SIMPLE,
          description: _unref(emptyDescription)
        }, null, 8, ["image", "description"])]),
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'orderNo' ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 0
        }, {
          title: _withCtx(() => [_createTextVNode("点击复制订单号")]),
          default: _withCtx(() => [_createElementVNode("div", {
            style: {
              "word-break": "break-all",
              "cursor": "pointer"
            },
            class: "order-copy-value",
            onClick: $event => _unref(copy)(record[column.dataIndex])
          }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_2)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'platOrderNo' ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 1
        }, {
          title: _withCtx(() => [_createTextVNode("点击复制三方订单号")]),
          default: _withCtx(() => [_createElementVNode("div", {
            style: {
              "word-break": "break-all",
              "cursor": "pointer"
            },
            class: "order-copy-value",
            onClick: $event => _unref(copy)(record[column.dataIndex])
          }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_3)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'deviceId' ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 2
        }, {
          title: _withCtx(() => [_createTextVNode("点击复制设备ID")]),
          default: _withCtx(() => [_createElementVNode("div", {
            style: {
              "word-break": "break-all",
              "cursor": "pointer"
            },
            class: "order-copy-value",
            onClick: $event => _unref(copy)(record[column.dataIndex])
          }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_4)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), column.key === 'operation' ? (_openBlock(), _createBlock(_component_a_button, {
          key: 3,
          class: "operation-btn",
          type: "link",
          onClick: $event => handleOperation(record)
        }, {
          default: _withCtx(() => [_createTextVNode("详情")]),
          _: 2
        }, 1032, ["onClick"])) : column.key === 'amount' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(record['currency']), 1), _createVNode(_component_a_statistic, {
          value: record['amount']
        }, null, 8, ["value"])])) : column.key === 'reshipStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", {
          class: _normalizeClass(["status-line", record['reshipStatus'] == '20' ? 'success' : ''])
        }, null, 2), _createElementVNode("span", null, _toDisplayString(record['reshipStatus'] == '20' ? '已复送' : record['reshipStatus'] == '10' ? '复送中' : '--'), 1)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["loading", "data-source", "scroll"]), !_unref(pageTotal) && (dataSource.value.length || _unref(pageIndex) > 1) ? (_openBlock(), _createBlock(_component_a_space, {
        key: 0,
        class: "table-pagination"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_button, {
          disabled: _unref(loading) || _unref(pageIndex) === 1,
          onClick: _cache[0] || (_cache[0] = $event => _unref(currentPageSizeChange)(_unref(pageIndex) - 1, _unref(pageSize)))
        }, {
          default: _withCtx(() => [_createTextVNode(" 上一页 ")]),
          _: 1
        }, 8, ["disabled"]), _createElementVNode("span", null, _toDisplayString(_unref(pageIndex)), 1), _createVNode(_component_a_button, {
          disabled: _unref(loading) || dataSource.value.length < _unref(pageSize),
          onClick: _cache[1] || (_cache[1] = $event => _unref(currentPageSizeChange)(_unref(pageIndex) + 1, _unref(pageSize)))
        }, {
          default: _withCtx(() => [_createTextVNode(" 下一页 ")]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_a_pagination, {
        key: 1,
        class: "table-pagination",
        disabled: _unref(loading),
        total: _unref(pageTotal),
        current: _unref(pageIndex),
        "onUpdate:current": _cache[2] || (_cache[2] = $event => _isRef(pageIndex) ? pageIndex.value = $event : null),
        pageSize: _unref(pageSize),
        "onUpdate:pageSize": _cache[3] || (_cache[3] = $event => _isRef(pageSize) ? pageSize.value = $event : null),
        onChange: _unref(currentPageSizeChange),
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["disabled", "total", "current", "pageSize", "onChange", "show-total"])), _createVNode(DuplicateDetail, {
        ref_key: "duplicateDetailRef",
        ref: duplicateDetailRef
      }, null, 512)]);
    };
  }
});